import { defineAsyncComponent } from 'vue'
export default {
  classroom: defineAsyncComponent(() => import("/vercel/path0/layouts/classroom.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/vercel/path0/layouts/empty.vue").then(m => m.default || m)),
  small: defineAsyncComponent(() => import("/vercel/path0/layouts/small.vue").then(m => m.default || m)),
  student: defineAsyncComponent(() => import("/vercel/path0/layouts/student.vue").then(m => m.default || m))
}